import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import React from 'react';

type Props = {
  isExcluded?: boolean;
  children: React.ReactNode;
};

export const ExcludedAmount = ({ isExcluded, children }: Props) => {
  const { lang } = getLocales();
  if (!isExcluded) return <>{children}</>;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Theme.Size.XXS }} title={lang.excluded}>
      <s style={{ opacity: 0.55 }}>{children}</s>
      <span
        style={{
          fontSize: '0.75em',
          fontWeight: 'bold',
          textTransform: 'uppercase',
          padding: '1px 6px',
          borderRadius: Theme.Size.XXS,
          border: `1px solid ${Theme.Color.warning}`,
          color: Theme.Color.warning,
          whiteSpace: 'nowrap',
        }}
      >
        {lang.excluded}
      </span>
    </span>
  );
};
